import React, { useEffect, useState } from 'react';

import { SkyPlayerContext } from './sky-player-context';
import { injectScripts } from './inject-scripts';
import { isClient } from '../../utils/device-utils';

declare global {
  interface Window {
    SkyPlayer: any;
    SkyPlayersManager: any;
  }
}
interface IDevice {
  children?: React.ReactNode | React.ReactNode[];
}

const SkyPlayerProvider: React.FC<IDevice> = ({ children }) => {
  const [skyPlayersManager, setSkyPlayersManager] = useState<any>();

  useEffect(() => {
    if (isClient()) {
      injectScripts()
        .then(() => {
          setSkyPlayersManager(new window.SkyPlayersManager({ async: true }));
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error('Error on injectScripts: ', err);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <SkyPlayerContext.Provider value={{ skyPlayersManager }}>{children}</SkyPlayerContext.Provider>;
};

export default SkyPlayerProvider;
